class Logger {
	private readonly prefix: string;

	constructor(
		name: string,
		private readonly styles?: { color?: string; backgroundColor?: string },
	) {
		this.prefix = styles ? `%c[${name}]` : `[${name}]`;
	}

	private get css(): string {
		const parts: string[] = [];

		if (this.styles?.color) {
			parts.push(`color: ${this.styles.color}`);
		}

		if (this.styles?.backgroundColor) {
			parts.push(`background-color: ${this.styles.backgroundColor}`);
		}

		if (parts.length) {
			parts.push("padding: 1px 4px", "border-radius: 2px");
		}

		return parts.join("; ");
	}

	log: typeof console.log = (...args) => {
		if (this.styles) {
			console.log(this.prefix, this.css, ...args);
		} else {
			console.log(this.prefix, ...args);
		}
	};

	warn: typeof console.warn = (...args) => {
		if (this.styles) {
			console.warn(this.prefix, this.css, ...args);
		} else {
			console.warn(this.prefix, ...args);
		}
	};

	error: typeof console.error = (...args) => {
		if (this.styles) {
			console.error(this.prefix, this.css, ...args);
		} else {
			console.error(this.prefix, ...args);
		}
	};
}

export { Logger };
